import { render, staticRenderFns } from "./dataRetrieval.vue?vue&type=template&id=72e25668&scoped=true"
import script from "./dataRetrieval.vue?vue&type=script&lang=js"
export * from "./dataRetrieval.vue?vue&type=script&lang=js"
import style0 from "./dataRetrieval.vue?vue&type=style&index=0&id=72e25668&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e25668",
  null
  
)

export default component.exports